import React from 'react';
import PropTypes from 'prop-types';

const CheckoutServerError = (props) => {
  if (props.message !== '') {
    return (
      <div className='form-errors'>
        <p>{props.message}</p>
      </div>
    );
  } else {
    return null;
  }
};

CheckoutServerError.propTypes = {
  message: PropTypes.string
};

export default CheckoutServerError;



// WEBPACK FOOTER //
// ./src/components/CheckoutServerError/index.js